import React, { useState } from "react";

/**
 * Mirrors the before/after slider card as it appears in the home gallery.
 * Includes the same draggable handle so admins can sanity-check the
 * alignment of the two photos before saving.
 */
const BeforeAfterPreview = ({ ba = {} }) => {
  const [pct, setPct] = useState(50);

  const before = ba.before_url;
  const after = ba.after_url;

  return (
    <div className="bg-slate-950 p-10 min-h-[500px]" data-testid="ba-preview">
      <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-6">
        Homepage · Before / After gallery
      </div>

      <div className="max-w-2xl mx-auto">
        <div className="glass rounded-2xl overflow-hidden">
          <div className="relative aspect-[4/3] bg-slate-900 select-none">
            {after ? (
              <img src={after} alt="after" className="absolute inset-0 w-full h-full object-cover" />
            ) : (
              <div className="absolute inset-0 flex items-center justify-center text-slate-600 text-sm">
                After image will appear here
              </div>
            )}
            {before && (
              <div
                className="absolute inset-0 overflow-hidden"
                style={{ width: `${pct}%` }}
              >
                <img
                  src={before}
                  alt="before"
                  className="absolute inset-0 h-full object-cover"
                  style={{ width: `calc(100% * 100 / ${pct})`, maxWidth: "none" }}
                />
              </div>
            )}

            <div className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-rose-500/80 text-white text-[10px] uppercase tracking-wider">Before</div>
            <div className="absolute top-3 right-3 px-2 py-0.5 rounded-full bg-atc-green/90 text-slate-950 text-[10px] uppercase tracking-wider">After</div>

            {before && after && (
              <>
                <div
                  className="absolute inset-y-0 w-0.5 bg-white/80 shadow-lg pointer-events-none"
                  style={{ left: `${pct}%`, transform: "translateX(-50%)" }}
                />
                <div
                  className="absolute h-9 w-9 rounded-full bg-white/95 text-slate-900 flex items-center justify-center font-bold cursor-ew-resize"
                  style={{ left: `${pct}%`, top: "50%", transform: "translate(-50%, -50%)" }}
                >
                  ⇆
                </div>
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={pct}
                  onChange={(e) => setPct(Number(e.target.value))}
                  className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
                  aria-label="Drag to compare before and after"
                />
              </>
            )}
          </div>

          <div className="p-5">
            <div className="font-display font-bold text-white text-lg">{ba.title || "Untitled comparison"}</div>
            {ba.description && (
              <div className="text-sm text-slate-300 mt-1">{ba.description}</div>
            )}
            {!ba.is_active && (
              <div className="mt-3 inline-block text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full bg-slate-700/30 text-slate-400">
                Hidden
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeforeAfterPreview;
